import { Link } from 'react-router-dom'
import HeroCanvas from '../components/HeroCanvas.jsx'

export default function HomePage() {
    return (
        <>
            {/* Hero */}
            <section className="hero">
                <HeroCanvas />
                <div className="hero-content">
                    <img src="/logo.png" alt="KaryonTech Logo" className="hero-logo" />
                    <h1>Building Blocks for <span className="gradient-text">Decentralized and Local-First</span> Software Systems</h1>
                    <p className="tagline">We build open source systems, tools, and infrastructure for developers.</p>
                    <div className="hero-buttons">
                        <a href="https://github.com/karyontech" className="btn btn-primary">Source Code</a>
                        <a href="#join-us" className="btn btn-outline">Join Us</a>
                    </div>
                </div>
            </section>

            {/* Mission */}
            <section className="mission">
                <div className="mission-inner">
                    <div className="mission-header">
                        <span className="mission-label">Core Principles</span>
                    </div>
                    <div className="mission-grid">
                        <div className="mission-card">
                            <span className="mission-num">01</span>
                            <h3>Decentralized First</h3>
                            <p>Tools built around peer-to-peer connectivity, privacy, and data sovereignty.</p>
                        </div>
                        <div className="mission-card">
                            <span className="mission-num">02</span>
                            <h3>Local-First in Mind</h3>
                            <p>Software built to work offline by default, ensuring user data remains local, private, and fully under their control.</p>
                        </div>
                        <div className="mission-card">
                            <span className="mission-num">03</span>
                            <h3>Modular by Design</h3>
                            <p>Components designed to be reusable, interoperable, and easy to integrate across different systems and use cases.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Projects */}
            <section id="projects" className="projects-section">
                <h2 className="section-title"><a href="#projects" className="section-anchor">Projects</a></h2>
                <p className="section-subtitle">The core libraries and tools we maintain.</p>
                <div className="projects">

                    {/* Karyon */}
                    <div className="project-card">
                        <div className="project-info">
                            <span className="project-tag">Networking &middot; Rust</span>
                            <h3>Karyon</h3>
                            <p>Composable Rust crates for networking, JSON-RPC, and decentralized peer-to-peer systems.</p>
                            <p>Supports layered transports, protocol negotiation, pluggable discovery, and swarm-based peer coordination.</p>
                            <div className="project-links">
                                <Link to="/karyon" className="btn btn-primary btn-sm">Learn More</Link>
                                <a href="https://github.com/karyontech/karyon" className="btn btn-outline btn-sm">Source Code</a>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Join Us */}
            <section id="join-us" className="join-us">
                <h2 className="section-title"><a href="#join-us" className="section-anchor">Join Us</a></h2>
                <p className="section-subtitle">Get in touch and join the community.</p>
                <div className="join-grid">
                    <a href="https://discord.gg/xuXRcrkz3p" className="join-card">
                        <span className="join-label">Discord</span>
                        <span className="join-value">discord.gg/xuXRcrkz3p</span>
                        <span className="join-arrow" aria-hidden="true">↗</span>
                    </a>
                    <a href="https://web.libera.chat/#karyon" className="join-card">
                        <span className="join-label">IRC</span>
                        <span className="join-value">#karyon on liberachat</span>
                        <span className="join-arrow" aria-hidden="true">↗</span>
                    </a>
                    <a href="#join-us" onClick={(e) => {
                        e.preventDefault()
                        const u = 'info', d = 'karyontech', t = 'net'
                        window.location.href = 'mai' + 'lto:' + u + String.fromCharCode(64) + d + '.' + t
                    }} className="join-card">
                        <span className="join-label">Email</span>
                        <span className="join-value">info<span>{String.fromCharCode(64)}</span>karyontech.net</span>
                        <span className="join-arrow" aria-hidden="true">↗</span>
                    </a>
                </div>
            </section>
        </>
    )
}
